@if (!jsonLoaded) {
  <div class="load_bg">
    <span class="load_img">
      @if (headerJson.logo != undefined) {
        <img [attr.src]="headerJson.logo | secure | async" class="org-logo">
      }
      <span>Loading...</span>
    </span>
  </div>
}

@if (jsonLoaded) {
  <router-outlet></router-outlet>
}

<!-- {{openVideocall | json}} -->
@if (openVideocall) {
  <div [ngClass]="{'modal': teleService.currentCall.fullScreen, 'modal-minplayer': !teleService.currentCall.fullScreen,'telemedicine-overlay': 'teleService.currentCall.fullScreen', 'remove-telemedicine-overlay' : !teleService.currentCall.fullScreen}"
    class="fade show" [ngStyle]="teleService.currentCall.minimized?{'top':'0'}:{'bottom': '10px'}" role="dialog"
    tabindex="-1" aria-modal="true" style="display: block;" id="videoModal">
    <div role="document" class="modal-dialog modal-lg modal-telemedicine">
      <div class="modal-content">
        <app-telemedicine>
        </app-telemedicine>
      </div>
    </div>
  </div>
}
<ngx-spinner class="test" bdOpacity=0.1 bdColor="#0000004f" size="medium" color="#fff" type="ball-clip-rotate">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<!-- Rendered at the app-shell level (not inside BaseComponent) so both persist across
     route/module navigation instead of being destroyed and recreated each time. isLoggedIn
     only changes on login/logout, so this gate keeps them off the login screen without
     reintroducing per-navigation teardown. app-chatbot-widget used to live inside
     coreui.layout.html (BaseComponent) — since BaseComponent is the route component for
     28 separate feature-module routes, navigating between feature modules destroyed and
     recreated it, wiping its one-time-code state and issuing a fresh authorization code
     (and a fresh tsl_chatbot_auth_code row) on every reopen. -->
@if (isLoggedIn) {
  <app-kx-ai-chat-embed></app-kx-ai-chat-embed>
  <app-chatbot-widget></app-chatbot-widget>
}